import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { FormFieldTooltip } from 'shared/components';

import theme from './FormFieldError.scss';

const propTypes = {
  tooltipType: PropTypes.oneOf(['text', 'hint', 'intl']),
  tooltipTestId: PropTypes.string,
  tooltipMessage: PropTypes.object,
  tooltipSize: PropTypes.oneOf(['medium', 'large']),
  tooltipWidth: PropTypes.number,
  tooltipPlacement: PropTypes.string,
};

const defaultProps = {
  tooltipType: 'intl',
  tooltipTestId: 'tooltip',
  tooltipMessage: null,
  tooltipSize: 'large',
  tooltipWidth: null,
  tooltipPlacement: 'bottomStart',
};

const FormFieldError = ({
  className,
  tooltipTestId,
  tooltipWidth,
  height,
  tooltipMessage,
  tooltipSize,
  tooltipPlacement,
  tooltipType,
}) => (
  <Choose>
    <When condition={ !tooltipMessage }>
      { null }
    </When>
    <When condition={ tooltipType === 'hint' }>
      <FormFieldTooltip
        testId={ tooltipTestId }
        width={ tooltipWidth }
        offset={ height }
        tooltipMessage={ tooltipMessage }
        tooltipSize={ tooltipSize }
        tooltipPlacement={ tooltipPlacement }
        className={ className }
      />
    </When>
    <When condition={ tooltipType === 'text' }>
      <div className={ classnames(theme.error, theme.fadeIn, className) } role="alert">
        { tooltipMessage }
      </div>
    </When>
    <Otherwise>
      <div
        className={ classnames(theme.error, theme.fadeIn, className) }
        style={{ width: tooltipWidth }}
        role="alert"
      >
        <FormattedMessage { ...tooltipMessage } />
      </div>
    </Otherwise>
  </Choose>
);

FormFieldError.propTypes = propTypes;
FormFieldError.defaultProps = defaultProps;

export default FormFieldError;
